import { render, staticRenderFns } from "./MyProjectsOverview.vue?vue&type=template&id=0985c734&scoped=true"
import script from "./MyProjectsOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsOverview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsOverview.vue?vue&type=style&index=0&id=0985c734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985c734",
  null
  
)

export default component.exports